module.exports = "<div id=\"map\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/map/map.component.html
// module id = ../../../../../src/app/components/map/map.component.html
// module chunks = main